<script lang="ts">
  import { FormGroup, Input} from "sveltestrap";
  import { BasicCheckbox, BasicSkinCheck, BasicSkinCheckMessage, DefaultCheckboxSquar, DefaultCheckboxSquarMesaage, DisableCheck, DisableCheckMessage, FlatSkinCheck, FlatSkinCheckMessage, InlineCheckbox, InlineCheckboxMessage } from "../../../../utils/Constant/Constant";
</script>
<tr>
    <td>{BasicCheckbox}</td>
    <FormGroup>
        <Input id="c1" type="checkbox" label="Default" />
    </FormGroup>
    <td><span>{BasicCheckbox}</span></td>
  </tr>
  <tr>
    <td>{DefaultCheckboxSquar}</td>
    <td>
        <FormGroup class="m-squar">
            <Input id="checkbox3" type="checkbox" label="Default" />
        </FormGroup>
    </td>
    <td><span>{@html DefaultCheckboxSquarMesaage}</span></td>
  </tr>
  <tr>
    <td>{BasicSkinCheck}</td>
    <td>
        <FormGroup class="checkbox-dark">
            <Input id="checkbox-state-dark" type="checkbox" label="Brand state" />
        </FormGroup>
    </td>
    <td><span>{@html BasicSkinCheckMessage}</span></td>
  </tr>
  <tr>
    <td>{FlatSkinCheck}</td>
    <td>
        <FormGroup class="checkbox-solid-primary">
            <Input id="solid6" checked type="checkbox" label="checked" />
        </FormGroup>
    </td>
    <td><span>{@html FlatSkinCheckMessage}</span></td>
  </tr>
  <tr>
    <td>{DisableCheck}</td>
    <td>
        <FormGroup class="checkbox-solid-primary">
            <Input id="solid7" disabled type="checkbox" label="checked" />
        </FormGroup>
    </td>
    <td><span>{@html DisableCheckMessage}</span></td>
  </tr>
  <tr>
    <td>{InlineCheckbox}</td>
    <td>
        <FormGroup class="m-b-0 m-checkbox-inline">
            <Input id="inline-1" color="primary"  type="checkbox" label="Option 1" />
            <Input id="inline-2" color="secondary"  type="checkbox" label="Option 1" />
            <Input id="inline-3" color="success"  type="checkbox" label="Option 1" />
        </FormGroup>
    </td>
    <td><span>{@html InlineCheckboxMessage}</span></td>
  </tr>